<template>
  <div class="wxa-visa-guides">
    <div class="left-navs">
      <div
        class="left-nav-item"
        v-for="(item, index) in guideVideos"
        :key="item.type_id"
        :class="{ active: currentTypeIndex === index }"
        @mouseenter="currentTypeIndex = index"
      >
        {{ item.type_name }}
      </div>
    </div>
    <div class="right-video-wrapper">
      <div class="right-videos" v-if="guideVideos[currentTypeIndex]">
        <router-link
          class="right-video-item"
          v-for="videoItem in guideVideos[currentTypeIndex].type_arr"
          :key="videoItem.id"
          :to="{ name: 'videoDetail', params: { id: videoItem.id } }"
          target="_blank"
        >
          <div class="video-icon"></div>
          <div class="video-name">{{ videoItem.title }}</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "wxa-visa-guides",
  props: {
    guideVideos: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      currentTypeIndex: 0
    }
  }
};
</script>

<style lang="less" scoped>
.wxa-visa-guides {
  margin-top: 28px;
  width: 475px;
  height: 346px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #dee2e6;
  display: flex;
  align-items: center;
  .left-navs {
    display: flex;
    flex-direction: column;
    width: 122px;
    height: 346px;
    background: #2e323b;
    border-radius: 2px 0px 0px 2px;
    .left-nav-item {
      width: 122px;
      height: 54px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 16px;
      line-height: 22px;
      cursor: pointer;
      &:hover,
      &.active {
        color: white;
        background: linear-gradient(90deg, #4f99ff 0%, #1f88ff 100%);
      }
    }
  }
  .right-video-wrapper {
    flex: 1;
    height: 100%;
    overflow-y: auto;
    background-color: white;
    .right-videos {
      display: flex;
      flex-direction: column;
      .right-video-item {
        width: 100%;
        height: 54px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e9eef2;
        .video-icon {
          width: 21px;
          height: 21px;
          background-image: url("../../../assets/imgs/acadmy/video.png");
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          margin-left: 15px;
          flex-shrink: 0;
        }
        .video-name {
          margin-left: 8px;
          font-size: 16px;
          font-weight: 400;
          color: #2f333d;
          line-height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &:hover {
          cursor: pointer;
          background-color: fade(#599fff, 4);
          .video-icon {
            background-image: url("../../../assets/imgs/acadmy/video-active.png");
          }
          .video-name {
            color: #599fff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/academy/components/wxa-visa-guides.vue